@if (!showSelector) {
  <div class="trigger-row">
    <p-button
      [label]="buttonLabel"
      icon="pi pi-pencil"
      (click)="toggleSelector()"
      [outlined]="true"
      styleClass="w-full model-selector-trigger">
    </p-button>
    @if (savedModelIsInactive) {
      <i
        class="pi pi-exclamation-triangle inactive-warning"
        [pTooltip]="inactiveTooltip"
        tooltipPosition="top">
      </i>
    }
  </div>
} @else {
  <app-model-selector
    [disableModelSelection]="disableModelSelection"
    [autoOpenTesterVersionId]="disableModelSelection ? selectedVersionId : undefined"
    [showPropertiesEdit]="showPropertiesEdit"
    [includeVersionSnapshots]="effectiveSnapshots"
    [modelTypes]="modelTypes"
    [modelsHierarchy]="modelsHierarchy"
    [multiSelect]="multiSelect"
    [allowModelSelect]="allowModelSelect"
    [showVersions]="showVersions"
    [allowSelectFromTester]="allowSelectFromTester"
    [currentAdditionalProperties]="currentAdditionalProperties"
    [currentVoiceId]="currentVoiceId"
    [currentTemperature]="currentTemperature"
    [currentTopK]="currentTopK"
    [currentTopP]="currentTopP"
    [currentMaxOutputTokens]="currentMaxOutputTokens"
    [versionSamplingParams]="versionSamplingParams"
    [customLlmGatewayCodes]="customLlmGatewayCodes"
    [currentCustomHeadersSchema]="currentCustomHeadersSchema"
    [currentCustomBodySchema]="currentCustomBodySchema"
    [includeAll]="includeAll"
    [hierarchyLoading]="hierarchyLoading"
    (includeAllChange)="includeAllChange.emit($event)"
    [excludeVersionIds]="excludeVersionIds"
    [selectedVersionIds]="effectiveSelectedIds"
    [defaultFirstMessage]="defaultFirstMessage"
    [languageId]="languageId"
    [localeId]="localeId"
    (selectionConfirmed)="onSelectionConfirmed($event)"
    (testerSelected)="testerSelected.emit($event)"
    (cancelled)="onCancelled()">
  </app-model-selector>
}
